import React, { useEffect, useState } from "react";
import { Send, Loader2, AudioWaveform } from "lucide-react";
import { api, formatApiError } from "@/lib/wolfApi";
import { toast } from "sonner";

export const DawgPanel = () => {
  const [stats, setStats] = useState(null);
  const [testEmail, setTestEmail] = useState("");
  const [sending, setSending] = useState(null);
  const [result, setResult] = useState(null);

  useEffect(() => {
    api.get("/dawg/stats").then((r) => setStats(r.data)).catch(() => {});
  }, []);

  const send = async (payload, mode) => {
    setSending(mode);
    try {
      const r = await api.post("/dawg/blast", payload);
      setResult(r.data);
      toast.success(mode === "test" ? `Test sent to ${r.data.sent_to}` : `DAWG blast sent to ${r.data.sent_count} 🐺🔴`);
    } catch (e) {
      toast.error(formatApiError(e));
    } finally {
      setSending(null);
    }
  };

  if (!stats) return null;

  return (
    <div className="mt-6 bg-[#111111] border border-[#FF2B2B]/30 p-6" data-testid="dawg-panel">
      <p className="text-[10px] uppercase tracking-[0.32em] text-[#FF2B2B]/90 mb-3">— WOLF DAWG · Admin</p>

      <div className="flex items-center gap-4">
        <AudioWaveform size={22} className="text-[#D4AF37]" />
        <div>
          <p className="font-display text-3xl text-[#D4AF37]" data-testid="dawg-signup-count">{stats.total}</p>
          <p className="text-[10px] uppercase tracking-[0.25em] text-white/45">On the launch list · {stats.blasted} already blasted</p>
        </div>
      </div>

      <div className="mt-5 flex gap-2">
        <input
          type="email"
          value={testEmail}
          onChange={(e) => setTestEmail(e.target.value)}
          placeholder="Send a test to yourself first…"
          data-testid="dawg-blast-test-email"
          className="flex-1 bg-[#0d0d0d] border border-white/15 focus:border-[#FF2B2B] outline-none text-sm text-white px-3 py-2.5"
        />
        <button
          onClick={() => testEmail && send({ test_email: testEmail }, "test")}
          disabled={!testEmail || sending !== null}
          data-testid="dawg-blast-test-btn"
          className="text-[10px] uppercase tracking-[0.25em] text-[#D4AF37] border border-[#D4AF37]/40 hover:border-[#D4AF37] disabled:opacity-50 px-4 py-2.5 transition-colors"
        >
          {sending === "test" ? <Loader2 size={12} className="animate-spin" /> : "Test"}
        </button>
      </div>

      <button
        onClick={() => window.confirm("Tell the ENTIRE WOLF DAWG list that downloads are live?") && send({ confirm: true }, "blast")}
        disabled={sending !== null}
        data-testid="dawg-blast-send-btn"
        className="mt-3 w-full inline-flex items-center justify-center gap-2 text-[11px] uppercase tracking-[0.28em] text-black bg-[#FF2B2B] hover:bg-[#ff4747] disabled:opacity-60 px-5 py-3.5 font-bold transition-colors"
      >
        {sending === "blast" ? <Loader2 size={14} className="animate-spin" /> : <Send size={14} />}
        Announce: Downloads are live
      </button>

      {result && result.mode === "blast" && (
        <p className="mt-3 text-[11px] text-white/55" data-testid="dawg-blast-result">
          Sent: {result.sent_count} · Already had it: {result.skipped_already_sent} · Failed: {result.failed_count}
        </p>
      )}
    </div>
  );
};
